import type {FC} from 'react';
import React, {Suspense} from 'react';

import ArticleListPaginated from '../../components/article-list-paginated';

import {type ArticleListAllFragment, articleListFromArticleListAllSection} from './query';

type Props = {
	data: ArticleListAllFragment;
	fullWidth?: boolean;
	insideToc?: boolean;
};

export const ArticleListAllContainer: FC<Props> = ({data, fullWidth, insideToc}) => {
	const {articles, fieldOfAreaFilters, totalArticles} =
		articleListFromArticleListAllSection(data);

	return (
		<Suspense>
			<ArticleListPaginated
				initialArticles={articles}
				totalArticles={totalArticles}
				fieldOfAreaFilters={fieldOfAreaFilters}
				areaFilters={[]}
				options={{fullWidth, ...data.contentBlockOptions}}
				insideToc={insideToc}
			/>
		</Suspense>
	);
};
